const Views = self => ({

  get allContacts() {
    if (self.numberOfOnDemandContacts === 0) { return []; }

    return Array.from(self.onDemandContacts.values()).filter(contact => !contact.isRevealed);
  },

  get hasOnDemandContact() {
    return self.allContacts.length > 0;
  },
  get selectedContact() {
    return self.onDemandContacts.get(self.selectedContactId);
  },

  get numberOfEmailsDisplayed() {
    return self.allContacts?.reduce((total, contact) => total + contact.totalEmailsCollected, 0);
  },

  get numberOfPhonesDisplayed() {
    return self.allContacts?.reduce((total, contact) => total + contact.totalPhonesCollected, 0);
  },

  get hasNewOnDemandContacts() {
    return self.numberOfNewOnDemandContacts > 0;
  },
});

export default Views;
